import {AdminAgreementsRepo} from './AdminAgreementsRepo'
import {AdminAgreementDTO, AdminAgreementJSON} from '../DTO/AdminAgreementDTO'
import {CommonResponseDTO, CommonResponseJSON} from '../../../../Network/CommonResponse'
import FetchWrapper from '../../../../Network/FetchWrapper'
import {withAdminsAuth} from '../../../../Network/BrowserFetchWrapper'
import {AdminAgreementDetail, AdminAgreementDetailDTO} from '../DTO/AdminAgreementDetailDTO'
import {DTO} from '../../../../Common/DtoUtilities'

export class NetworkAdminAgreementsRepo implements AdminAgreementsRepo {
  private fetchWrapper: FetchWrapper
  private serverUrl = process.env.REACT_APP_MEMBUCKET_ADMIN_APP_SERVER_URL

  constructor(fetchWrapper: FetchWrapper) {
    this.fetchWrapper = fetchWrapper
  }

  getSystemList(): Promise<CommonResponseDTO<AdminAgreementDTO[]>> {
    return this.fetchWrapper.getByJson(`${this.serverUrl}/v1/a/r/agreements`, withAdminsAuth())
      .then((response: CommonResponseJSON<AdminAgreementJSON[]>) =>
        CommonResponseDTO.fromArray(response, AdminAgreementDTO.fromJSON),
      )
  }

  getListByBucketKey(bucketKey: string): Promise<CommonResponseDTO<AdminAgreementDTO[]>> {
    return this.fetchWrapper.getByJson(
      `${this.serverUrl}/v1/a/r/agreements?bucket_key=${bucketKey}`,
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<AdminAgreementJSON[]>) =>
      CommonResponseDTO.fromArray(response, AdminAgreementDTO.fromJSON),
    )
  }

  getSystemById(id: number): Promise<CommonResponseDTO<AdminAgreementDetailDTO | null>> {
    return this.fetchWrapper.getByJson(
      `${this.serverUrl}/v1/a/r/agreements/${id}`,
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<AdminAgreementDetailDTO>) =>
      CommonResponseDTO.from(response, AdminAgreementDetailDTO.fromJSON),
    )
  }

  getByBucketKeyAndId(
    bucketKey: string, id: number,
  ): Promise<CommonResponseDTO<AdminAgreementDetailDTO | null>> {
    return this.fetchWrapper.getByJson(
      `${this.serverUrl}/v1/a/r/agreements/${id}?bucket_key=${bucketKey}`,
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<AdminAgreementDetailDTO>) =>
      CommonResponseDTO.from(response, AdminAgreementDetailDTO.fromJSON),
    )
  }

  getActiveByBucketKey(
    bucketKey: string,
  ): Promise<CommonResponseDTO<AdminAgreementDetailDTO | null>> {
    return this.fetchWrapper.getByJson(
      `${this.serverUrl}/v1/a/r/active_agreement?bucket_key=${bucketKey}`,
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<AdminAgreementDetailDTO>) =>
      CommonResponseDTO.from(response, AdminAgreementDetailDTO.fromJSON),
    )
  }

  create(agreementDetail: AdminAgreementDetail): Promise<CommonResponseDTO<number | null>> {
    return this.fetchWrapper.postJson(
      `${this.serverUrl}/v1/a/r/agreements`,
      DTO.toObject(agreementDetail),
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<number>) =>
      CommonResponseDTO.from(response, CommonResponseDTO.NO_CONVERT),
    )
  }

  delete({id, bucketKey}: AdminAgreementDetail): Promise<CommonResponseDTO<null>> {
    const queryParams = bucketKey == null ? '' : `?bucket_key=${bucketKey}`
    return this.fetchWrapper.deleteJson(
      `${this.serverUrl}/v1/a/r/agreements/${id}${queryParams}`, withAdminsAuth(),
    ).then((response: CommonResponseJSON<null>) => CommonResponseDTO.ofNullData(response))
  }
}
